class TMv_ProjectShowcase {

	standard_width;
	focus_width;
	gap_width = 16; // the gap between items
	left_buffer;
	showcase_container;
	showing = 1;
	num_items = 0;
	timer_ms = 3000; // milliseconds between each one
	transition_ms = 600; // how long the movement takes
	transition_space_ms = 50;
	main_timeout = null;
	cleanup_timeout = null;
	left_value = 0;

	constructor(element, params)
	{
		this.element = element;

		this.standard_width = params.standard_width;
		this.focus_width = params.focus_width;
		this.left_buffer = Math.floor(this.focus_width/2);
		this.showcase_container = this.element.querySelector('.showcases');

		// Event listeners for left/right button
		this.element.querySelector('#showcase_control_left').addEventListener('click',this.showPrevious.bind(this));
		this.element.querySelector('#showcase_control_right').addEventListener('click',this.showNext.bind(this));
		this.num_items = this.element.querySelectorAll('.TMv_ProjectPreview').length;

		// this.element.querySelectorAll('.controls .project_button').forEach(el => {
		// 	el.addEventListener('click', this.projectControlClick.bind(this));
		// });

		// Take the last one, move it to the front, needed for movement
		this.left_value = '-'+(this.standard_width + this.gap_width);
		let last_showcase = this.element.querySelector('.TMv_ProjectPreview:last-child');
		this.showcase_container.prepend(last_showcase);
		this.showcase_container.style.left = this.left_value + 'px';

		// Set the initial timer
		this.startAutoScroll();

	}

	/**
	 * Handles when a project control button is clicked
	 * @param event
	 */
	projectControlClick(event) {
		event.preventDefault();
		let button = event.currentTarget;
		let num = button.getAttribute('data-num');
		this.showItemNumber(num);
	}

	/**
	 * Shows the next one
	 */
	showNext(event = null) {

		this.runTimeoutCleanups();

		// If it came from a click, stop that from doing anything
		if(event)
		{
			event.preventDefault();
		}


		// Transition the container
		this.showcase_container.style.transition = "left "+ this.transition_ms + "ms";
		this.showcase_container.style.left = (this.left_value * 2) + 'px';

		// Increase the counter
		this.showing++;
		if(this.showing > this.num_items)
		{
			this.showing = 1;
		}

		// Update the elements, also triggers the resizing
		this.updateFocusElements();

		// Cleanup timeout, which happens separately from the next one
		// Handled with an internal fuction so it's saved in the context of the closure
		this.cleanup_timeout = this.createTimeout(() => {
			//console.log('cleanup');


			// Move the first one (now hidden) to the end
			let first_showcase = this.element.querySelector('.TMv_ProjectPreview');
			this.showcase_container.append(first_showcase);

			// remove the transition, move the container immediately
			this.showcase_container.style.transition = null;
			this.showcase_container.style.left = this.left_value + 'px';

			// Clean itself to avoid additional triggers
			this.cleanup_timeout = null;
		}, this.transition_ms+this.transition_space_ms); // wait an additional ms to complete the CSS transitions

		// Trigger the next one
		this.startAutoScroll();


	}

	/**
	 * Shows the previous item
	 * @param {Event} event
	 */
	showPrevious(event = null) {
		//console.log('showPrevious');
		this.runTimeoutCleanups();

		// If it came from a click, stop that from doing anything
		if(event)
		{
			event.preventDefault();
		}

		// Transition the container, moving the hidden left one, into frame
		this.showcase_container.style.transition = "left "+ this.transition_ms + "ms";
		this.showcase_container.style.left = 0;

		// Increase the counter
		this.showing--;
		if(this.showing == 0 )
		{
			this.showing = this.num_items;
		}

		// Update the elements, also triggers the resizing
		this.updateFocusElements();



		// Cleanup timeout, which happens separately from the next one
		// Handled with an internal function so it's saved in the context of the closure
		this.cleanup_timeout = this.createTimeout(() => {
			//console.log('previous cleanup');
			// Move the last one, to the front for consistency
			let last_showcase = this.element.querySelector('.TMv_ProjectPreview:last-child');
			this.showcase_container.prepend(last_showcase);

			// remove the transition, move the container immediately
			this.showcase_container.style.transition = null;
			this.showcase_container.style.left = this.left_value + 'px';

			// Clean itself to avoid additional triggers
			this.cleanup_timeout = null;
		}, this.transition_ms+this.transition_space_ms); // wait an additional 100 ms to complete the CSS transitions

		// Trigger the next one
		this.startAutoScroll();

	}


	/**
	 * Straight swap to the nearest one
	 * @param num
	 */
	showItemNumber(num){

		this.runTimeoutCleanups();

		// Something else, go forward that many times.
		if(num > this.showing)
		{
			let num_to_shift = num - this.showing;
			for(let count = 1; count <= num_to_shift; count++)
			{
				let first_child = this.showcase_container.querySelector('.TMv_ProjectPreview');
				this.showcase_container.append(first_child);
			}

		}
		else if(num < this.showing)
		{
			let num_to_shift = this.showing - num;
			for(let count = 1; count <= num_to_shift; count++)
			{
				let last_child = this.showcase_container.querySelector('.TMv_ProjectPreview:last-child');
				this.showcase_container.prepend(last_child);
			}
		}


		this.showing = num;
		this.updateFocusElements();

		// Trigger the next one
		this.startAutoScroll();


	}

	updateFocusElements() {
		this.element.querySelector('.showcases .focus')?.classList.remove('focus');
	//	this.element.querySelector('.controls .focus').classList.remove('focus');
		document.querySelector('.TMv_ProjectShowcaseDetails .focus')?.classList.remove('focus');


		// FIND ALL the elements that are showcase numbered, there should be two
		document.querySelectorAll('.showcase_num_' + this.showing).forEach(el => {
			el.classList.add('focus');
		});
	}

	/**
	 * Creates a timeout closure that allows us to trigger and clear timeouts with more control
	 * @param timeoutHandler
	 * @param delay
	 * @returns {{clear: clear, trigger: (function(): *)}}
	 * @see https://stackoverflow.com/questions/7689233/force-settimeout-to-fire-its-payload-earlier-than-originally-set
	 */
	createTimeout(timeoutHandler, delay) {
		let timeout_id;
		timeout_id = setTimeout(timeoutHandler, delay);
		return {
			clear: () => {
				clearTimeout(timeout_id);
			},
			trigger: () => {
				clearTimeout(timeout_id);
				return timeoutHandler();
			}
		};
	}

	runTimeoutCleanups() {
		// Trigger any cleanup timers
		if(this.cleanup_timeout)
		{
			this.cleanup_timeout.trigger();
			this.cleanup_timeout = null;
		}

		// Clear the timeout regardless
		if(this.main_timeout)
		{
			this.main_timeout.clear();
			this.main_timeout = null;
		}
	}

	/**
	 * Starts the auto scroll of the next one
	 */
	startAutoScroll() {
		this.main_timeout = this.createTimeout(() => {
			this.showNext(null);
		}, this.timer_ms);
	}
}